<template>
  <div class="js-toggle-item-01 js-clear-01" id="anc-04">
    <h2 class="hdg-page-02 js-toggle-hdg-01">
      <button
        type="button"
        class="js-toggle-ui-01"
        @click="showPackageSetting = !showPackageSetting"
        :aria-expanded="showPackageSetting"
        id="expandPackageInfo"
      >
        <span>{{ $t("KYG071001.label.luggage_hinmoku_setting") }}</span>
      </button>
    </h2>

    <div class="js-toggle-content-01 mt-03" v-if="showPackageSetting">
      <p class="txt-lead-02" v-if="isError">
        <strong>{{ $t("Error.business.InputError") }}</strong>
      </p>

      <h3 class="hdg-page-03">
        <span>{{ $t("KYG071001.label.luggage_setting") }}</span>
      </h3>
      <h4 class="hdg-page-04">
        <span>{{ $t("KYG071001.label.export_info") }}</span>
      </h4>

      <fieldset class="form-fieldset-01">
        <legend class="flex">
          <span>{{ $t("KYG071001.label.actual_weight") }}</span>
          <strong class="required-01">{{
            $t("KYG071001.label.required")
          }}</strong>
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG071001.label.placeholder_gross_weight')"
                  v-model="packageModel.grossWeight"
                  maxlength="7"
                  v-active-validate="() => $v.packageModel.grossWeight.$touch()"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.grossWeight.$error ||
                      errors.get(keyParams.grossWeight)
                  }"
                  @input="
                    isActiveGrossWeight = false;
                    removeError(keyParams.grossWeight);
                  "
                  @blur="isActiveGrossWeight = true"
                ></input-format-number>
                <span class="unit">
                  {{ packageModel.weightUnitCdDisplay }}
                </span>
              </label>
            </li>
          </ul>
          <error-message
            :validate="$v.packageModel.grossWeight"
            :value="packageModel.grossWeight"
            :itemName="$t('KYG071001.validate.params.gross_weight')"
            :error="errors.get(keyParams.grossWeight)"
            :overSizeLabel="
              serviceKbn === '01'
                ? $t('ParamMessage.OverSizeLabel01')
                : $t('ParamMessage.OverSizeLabel03')
            "
          ></error-message>
        </div>
      </fieldset>

      <fieldset class="form-fieldset-01">
        <legend class="flex">
          <span>{{ $t("KYG071001.label.volume_weight") }}</span>
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG071001.label.placeholder_net_weight')"
                  v-model="packageModel.netWeight"
                  maxlength="7"
                  v-active-validate="() => $v.packageModel.netWeight.$touch()"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.netWeight.$error ||
                      errors.get(keyParams.netWeight)
                  }"
                  @input="
                    isActiveNetWeight = false;
                    removeError(keyParams.netWeight);
                  "
                  @blur="isActiveNetWeight = true"
                ></input-format-number>
                <span class="unit">
                  {{ packageModel.weightUnitCdDisplay }}
                </span>
              </label>
            </li>
          </ul>
          <error-message
            :validate="$v.packageModel.netWeight"
            :value="packageModel.netWeight"
            :itemName="$t('KYG071001.validate.params.volume_weight_label')"
            :error="errors.get(keyParams.netWeight)"
            :overSizeLabel="
              serviceKbn === '01'
                ? $t('ParamMessage.OverSizeLabel01')
                : $t('ParamMessage.OverSizeLabel03')
            "
          ></error-message>
        </div>
      </fieldset>

      <!-- 有償／無償 -->
      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend>
          <label for="select-03-01" class="flex">
            {{ $t("KYG071001.label.paid_free") }}
            <strong class="required-01">{{
              $t("KYG071001.label.required")
            }}</strong>
          </label>
        </legend>
        <div class="inner">
          <p class="mb-00">
            <span class="form-select-01 is-large">
              <select
                id="select-03-01"
                required
                v-model="$v.packageModel.paidFreeKbn.$model"
                :class="{
                  'form-error-01':
                    $v.packageModel.paidFreeKbn.$error ||
                    errors.get(keyParams.paidDiv)
                }"
                @change="removeError(keyParams.paidDiv)"
              >
                <option :value="null" disabled>{{
                  $t("Common.option_choose")
                }}</option>
                <option
                  v-for="item in listPaidFreeKbn"
                  :key="item.sbtNaiID"
                  :value="item.sbtNaiID"
                >
                  {{ item.stringValue }}
                </option>
              </select>
            </span>
          </p>
          <error-message
            :validate="$v.packageModel.paidFreeKbn"
            :value="packageModel.paidFreeKbn"
            :itemName="$t('KYG071001.label.paid_free')"
            :error="errors.get(keyParams.paidDiv)"
          ></error-message>
        </div>
      </fieldset>

      <!-- 通貨 -->
      <fieldset class="form-fieldset-01">
        <legend class="flex">{{ $t("KYG071001.label.currency") }}</legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input type="text" class="disabled" disabled />
                <span class="unit">{{ packageModel.currencyCdDisplay }}</span>
              </label>
            </li>
          </ul>
        </div>
      </fieldset>

      <!-- 建値 -->
      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">{{ $t("KYG071001.label.quoted_price") }}</legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input type="text" class="disabled" disabled />
                <span class="unit">{{ packageModel.shipmentTermDisplay }}</span>
              </label>
            </li>
          </ul>
        </div>
      </fieldset>

      <!-- 縦幅（L） -->
      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">
          {{ $t("KYG021001.label.length") }}
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG071001.label.placeholder_length')"
                  maxlength="5"
                  v-model="packageModel.length"
                  v-active-validate="validateLengthWidthHeight()"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.length.$error ||
                      errors.get(keyParams.length)
                  }"
                  @input="
                    isActiveLength = false;
                    removeError(keyParams.length);
                  "
                  @blur="isActiveLength = true"
                >
                </input-format-number>
                <span class="unit">{{
                  lengthUnidCd && lengthUnidCd.stringValue
                }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.length"
          :value="packageModel.length"
          :error="errors.get(keyParams.length)"
          :itemName="$t('KYG021001.label.length_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <!-- 横幅（W） -->
      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">
          {{ $t("KYG021001.label.width") }}
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG071001.label.placeholder_width')"
                  maxlength="5"
                  v-model="packageModel.width"
                  v-active-validate="validateLengthWidthHeight()"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.width.$error ||
                      errors.get(keyParams.width)
                  }"
                  @input="
                    isActiveWidth = false;
                    removeError(keyParams.width);
                  "
                  @blur="isActiveWidth = true"
                >
                </input-format-number>
                <span class="unit">{{
                  lengthUnidCd && lengthUnidCd.stringValue
                }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.width"
          :value="packageModel.width"
          :error="errors.get(keyParams.width)"
          :itemName="$t('KYG021001.label.width_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <!-- 高さ（H） -->
      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">
          {{ $t("KYG021001.label.height") }}
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG071001.label.placeholder_height')"
                  maxlength="5"
                  v-model="packageModel.height"
                  v-active-validate="validateLengthWidthHeight()"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.height.$error ||
                      errors.get(keyParams.height)
                  }"
                  @input="
                    isActiveHeight = false;
                    removeError(keyParams.height);
                  "
                  @blur="isActiveHeight = true"
                >
                </input-format-number>
                <span class="unit">{{
                  lengthUnidCd && lengthUnidCd.stringValue
                }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.height"
          :value="packageModel.height"
          :error="errors.get(keyParams.height)"
          :itemName="$t('KYG021001.label.height_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <!-- クール区分 -->
      <fieldset class="form-fieldset-01" v-if="serviceKbn === '03'">
        <legend class="flex">
          {{ $t("KYG021001.label.cool_category") }}
          <strong class="required-01">{{
            $t("KYG021001.label.required")
          }}</strong>
        </legend>
        <div class="inner">
          <ul class="form-radio-01">
            <li v-for="cool in listCoolKbn" :key="cool.sbtNaiID">
              <label>
                <input
                  type="radio"
                  name="coolKbn"
                  v-model="$v.packageModel.coolKbn.$model"
                  :value="cool.sbtNaiID"
                  :class="{
                    'form-error-01':
                      $v.packageModel.coolKbn.$error ||
                      errors.get(keyParams.coolDiv)
                  }"
                  @change="removeError(keyParams.coolDiv)"
                />
                <span>{{ cool.stringValue }}</span>
              </label>
            </li>
            <!-- /.form-radio-01 -->
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.coolKbn"
          :value="packageModel.coolKbn"
          :error="errors.get(keyParams.coolDiv)"
          :itemName="$t('KYG021001.label.cool_category')"
        ></error-message>
      </fieldset>

      <!-- 備考  -->
      <fieldset class="form-fieldset-01">
        <legend>
          <label for="textarea-03-01" class="flex">{{
            $t("KYG071001.label.note")
          }}</label>
        </legend>
        <div class="inner">
          <div class="form-input-02 long-01">
            <span class="input long-01">
              <input
                type="text"
                id="textarea-03-01"
                required
                placeholder=" "
                v-model="packageModel.note1"
                v-active-validate="() => $v.packageModel.note1.$touch()"
                :class="{
                  'form-error-01':
                    $v.packageModel.note1.$error || errors.get(keyParams.note1)
                }"
                maxlength="35"
                @input="removeError(keyParams.note1)"
              />
            </span>
          </div>
          <error-message
            :validate="$v.packageModel.note1"
            :value="packageModel.note1"
            :itemName="$t('KYG071001.validate.params.note1')"
            max-digit="35"
            :error="errors.get(keyParams.note1)"
          ></error-message>
          <div class="form-input-02 long-01 mt-01">
            <span class="input long-01">
              <input
                type="text"
                id="textarea-03-02"
                required
                placeholder=" "
                v-model="packageModel.note2"
                v-active-validate="() => $v.packageModel.note2.$touch()"
                maxlength="35"
                :class="{
                  'form-error-01':
                    $v.packageModel.note2.$error || errors.get(keyParams.note2)
                }"
                @input="removeError(keyParams.note2)"
              />
            </span>
          </div>
          <error-message
            :validate="$v.packageModel.note2"
            :value="packageModel.note2"
            :itemName="$t('KYG071001.validate.params.note2')"
            max-digit="35"
            :error="errors.get(keyParams.note2)"
          ></error-message>
        </div>
      </fieldset>

      <!-- 支払い方法 -->
      <h4 class="hdg-page-04">
        <span>{{ $t("KYG021001.label.payment_method") }}</span>
      </h4>
      <!-- 関税等諸費用の支払い方法 -->
      <fieldset class="form-fieldset-01">
        <legend class="flex">
          {{ $t("KYG021001.label.pay_custom_fees_method") }}
          <strong class="required-01">{{
            $t("KYG021001.label.required")
          }}</strong>
        </legend>
        <div class="inner">
          <ul class="form-radio-01">
            <li v-for="payment in listPaymentDiv" :key="payment.sbtNaiID">
              <label>
                <input
                  type="radio"
                  name="paymentDiv"
                  v-model="$v.packageModel.paymentDiv.$model"
                  :value="payment.sbtNaiID"
                  :class="{
                    'form-error-01':
                      $v.packageModel.paymentDiv.$error ||
                      errors.get(keyParams.paymentDiv)
                  }"
                  :disabled="payment.sbtNaiID === '3' && shipmentDiv === 'D'"
                  @change="removeError(keyParams.paymentDiv)"
                />
                <span>{{ payment.stringValue }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.paymentDiv"
          :value="packageModel.paymentDiv"
          :error="errors.get(keyParams.paymentDiv)"
          :itemName="$t('KYG021001.label.pay_custom_fees_method')"
        ></error-message>
      </fieldset>

      <!-- IOSS VAT登録者 -->
      <template v-if="isShowVatSetting">
        <h4 class="hdg-page-04">
          <span>{{ this.$t("KYG071001.label.vat_register") }}</span>
        </h4>
        <fieldset class="form-fieldset-01">
          <legend class="flex">
            <span>{{ this.$t("KYG071001.label.vat_register_div") }}</span>
            <strong class="required-01">
              {{ $t("KYG071001.label.required") }}
            </strong>
          </legend>
          <div class="inner">
            <ul
              class="form-radio-01"
              v-bind:class="isShowVatSelectCol3 ? 'col3' : 'col2'"
            >
              <template v-for="vatRegister in listVatInputDiv">
                <li :key="vatRegister.sbtNaiID">
                  <label>
                    <input
                      type="radio"
                      name="vatRegisterDiv"
                      v-model="$v.packageModel.vatRegisterDiv.$model"
                      :value="vatRegister.sbtNaiID"
                      :class="{
                        'form-error-01':
                          $v.packageModel.vatRegisterDiv.$error ||
                          errors.get(keyParams.vatRegisterDiv)
                      }"
                      @change="clearVatError()"
                    />
                    <span>{{ vatRegister.stringValue }}</span>
                  </label>
                </li>
              </template>
            </ul>
            <p class="txt-alert-01 link-txt-01" v-show="vatSelectionDetail">
              <strong>
                {{ vatSelectionDetail }}
                <a @click.prevent="showVATSelectionDetail()">
                  {{ $t("KYG071001.label.here") }}
                </a>
              </strong>
            </p>
          </div>
          <error-message
            :validate="$v.packageModel.vatRegisterDiv"
            :value="packageModel.vatRegisterDiv"
            :error="errors.get(keyParams.vatRegisterDiv)"
            :itemName="$t('KYG071001.label.vat_register_div')"
            max-digit="2"
          ></error-message>
        </fieldset>
        <fieldset class="form-fieldset-01" v-if="isShowVatNumber">
          <legend class="flex">
            <span>{{ $t("KYG071001.label.vat_register_number") }}</span>
            <strong class="required-01">
              {{ $t("KYG071001.label.required") }}
            </strong>
          </legend>
          <div class="inner">
            <ul class="form-list-01">
              <li>
                <label class="form-input-01">
                  <input
                    type="text"
                    v-model="packageModel.vatRegisterNumber"
                    :placeholder="vatInputPlaceholder"
                    v-active-validate="
                      () => $v.packageModel.vatRegisterNumber.$touch()
                    "
                    maxlength="35"
                    @input="removeError(keyParams.vatRegisterNumber)"
                    :class="{
                      'form-error-01':
                        $v.packageModel.vatRegisterNumber.$error ||
                        errors.get(keyParams.vatRegisterNumber)
                    }"
                  />
                </label>
              </li>
            </ul>
          </div>
          <error-message
            :validate="$v.packageModel.vatRegisterNumber"
            :value="packageModel.vatRegisterNumber"
            :error="errors.get(keyParams.vatRegisterNumber)"
            :itemName="$t('KYG071001.label.vat_register_number')"
            max-digit="35"
          ></error-message>
        </fieldset>
      </template>

      <!-- インボイス発行 -->
      <template v-if="shipmentDiv">
        <h4 class="hdg-page-04">
          <span>{{ $t("KYG021001.label.invoice") }}</span>
        </h4>
        <fieldset class="form-fieldset-01">
          <legend class="flex">
            {{ $t("KYG021001.label.invoice_create") }}
            <strong class="required-01">{{
              $t("KYG021001.label.required")
            }}</strong>
          </legend>
          <div class="inner">
            <ul class="form-radio-01">
              <li
                v-for="invoiceOutDiv in listInvoiceOutDiv"
                :key="invoiceOutDiv.sbtNaiID"
              >
                <label>
                  <input
                    type="radio"
                    name="invoiceOutDiv"
                    v-model="$v.packageModel.invoiceOutDiv.$model"
                    :value="invoiceOutDiv.sbtNaiID"
                    :class="{
                      'form-error-01':
                        $v.packageModel.invoiceOutDiv.$error ||
                        errors.get(keyParams.invoiceOutDiv)
                    }"
                    @change="removeError(keyParams.invoiceOutDiv)"
                  />
                  <span>{{ invoiceOutDiv.stringValue }}</span>
                </label>
              </li>
              <!-- /.form-radio-01 -->
            </ul>
            <p
              class="txt-alert-01 link-txt-01"
              v-if="!this.displayNonDocumentItem"
            >
              <strong>
                {{
                  $t("KYG021001.label.please_unnecessary_invoice_for_documents")
                }}
              </strong>
            </p>
          </div>
          <error-message
            :validate="$v.packageModel.invoiceOutDiv"
            :value="packageModel.invoiceOutDiv"
            :error="errors.get(keyParams.invoiceOutDiv)"
            :itemName="$t('KYG021001.label.invoice_create')"
            max-digit="2"
          ></error-message>
        </fieldset>
      </template>

      <h3 class="hdg-page-03">
        <span>{{ $t("KYG071001.label.hinmoku_setting") }}
            <a class="txt-question-01 link-txt-01" @click.prevent="showHinmokuSetting"></a>
        </span>
      </h3>
      <template v-if="issueInvoiceFlg">
        <p class="txt-alert-01 link-txt-01">
          <strong>
            {{ $t("KYG021001.label.please_enter_all_of_package_info") }}
          </strong>
        </p>

        <div
          class="box-error-01"
          v-if="listErrorMessageItems && listErrorMessageItems.length > 0"
        >
          <ul>
            <li v-for="(item, index) in listErrorMessageItems" :key="index">
              <error-message :error="item"></error-message>
            </li>
          </ul>
        </div>

        <div class="box-error-01" v-if="errors.get('itemInfo')">
          <ul>
            <li>
              <error-message :error="errors.get('itemInfo')"></error-message>
            </li>
          </ul>
        </div>
        <div id="table-list-item" class="box-scroll-03 dialog">
          <table class="tbl-data-01 js-tbl-width-01">
            <thead>
              <tr>
                <th class="w-01">{{ $t("KYG071001.label.no_with_dot") }}</th>
                <th class="w-2">
                  {{ $t("KYG071001.label.header_reference") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG071001.label.header_item_code") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG071001.label.header_item_name") }}
                </th>
                <th class="w-6">
                  {{ $t("KYG071001.label.header_hs_code") }}
                </th>
                <th class="w-5">
                  {{ $t("KYG071001.label.header_origin_country") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG071001.label.header_unit_price") }}
                </th>
                <th class="w-4">{{ $t("KYG071001.label.header_unit") }}</th>
                <th class="w-4">{{ $t("KYG071001.label.header_quantity") }}</th>
                <th class="w-4">{{ $t("KYG071001.label.header_total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in packageModel.listItems" :key="index">
                <td class="w-01">{{ item.no }}</td>
                <td class="w-2">
                  <button
                    type="button"
                    class="tbl-clear-01"
                    @click="deleteItem(index)"
                  >
                    {{ $t("KYG071001.label.delete") }}
                  </button>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input
                      type="text"
                      maxlength="16"
                      :placeholder="$t('KYG071001.label.placeholder_hincode')"
                      v-model="item.itemCd"
                      :class="{
                        itemtableerror:
                          arrItemError.get('itemInfo[' + index + '].itemCd') ||
                          errors.get('itemInfo[' + index + '].itemCd')
                      }"
                      @input="removeError('itemInfo[' + index + '].itemCd')"
                    />
                  </label>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input
                      type="text"
                      maxlength="105"
                      :placeholder="$t('KYG071001.label.placeholder_hinname')"
                      v-model="item.itemName"
                      @change="updateListPresent()"
                      @input="removeError('itemInfo[' + index + '].itemName')"
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].itemName'
                          ) || errors.get('itemInfo[' + index + '].itemName')
                      }"
                    />
                  </label>
                </td>
                <td class="w-6">
                  <label class="form-input-03">
                    <input
                      type="text"
                      maxlength="15"
                      :placeholder="$t('KYG071001.label.placeholder_hs')"
                      v-model="item.hsCd"
                      @change="item.hsCd = trimValue(item.hsCd)"
                      @input="removeError('itemInfo[' + index + '].hsCd')"
                      :class="{
                        itemtableerror:
                          arrItemError.get('itemInfo[' + index + '].hsCd') ||
                          errors.get('itemInfo[' + index + '].hsCd')
                      }"
                    />
                  </label>
                </td>
                <td class="w-5">
                  <span class="form-select-01 is-small">
                    <select
                      v-model="item.originCountry"
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].originCountryId'
                          ) ||
                          errors.get('itemInfo[' + index + '].originCountryId')
                      }"
                      @change="
                        removeError('itemInfo[' + index + '].originCountryId')
                      "
                    >
                      <option :value="null" disabled>{{
                        $t("Common.option_choose")
                      }}</option>
                      <option
                        v-for="country in listOriginCountry"
                        :key="country.originCountryId"
                        :value="country"
                      >
                        {{ country.originCountryName }}
                      </option>
                    </select>
                  </span>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input-format-number
                      maxlength="10"
                      class="ta-r"
                      :placeholder="
                        $t('KYG071001.label.placeholder_unit_price')
                      "
                      v-model="item.valueOfUnit"
                      @input="
                        removeError('itemInfo[' + index + '].valueOfUnit')
                      "
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].valueOfUnit'
                          ) || errors.get('itemInfo[' + index + '].valueOfUnit')
                      }"
                    ></input-format-number>
                  </label>
                </td>
                <td class="w-4">
                  <span class="form-select-01 is-small">
                    <select
                      v-model="item.unit"
                      :class="{
                        itemtableerror:
                          arrItemError.get('itemInfo[' + index + '].unitCd') ||
                          errors.get('itemInfo[' + index + '].unitCd')
                      }"
                      @change="removeError('itemInfo[' + index + '].unitCd')"
                    >
                      <option :value="null" disabled>{{
                        $t("Common.option_choose")
                      }}</option>
                      <option
                        v-for="item in listUnit"
                        :key="item.unitCd"
                        :value="item"
                      >
                        {{ item.unitName }}
                      </option>
                    </select>
                  </span>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input-format-number
                      :placeholder="$t('KYG071001.label.placeholder_quantity')"
                      maxlength="4"
                      v-model="item.quantity"
                      class="ta-r"
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].quantity'
                          ) || errors.get('itemInfo[' + index + '].quantity')
                      }"
                      @input="removeError('itemInfo[' + index + '].quantity')"
                    >
                    </input-format-number>
                  </label>
                </td>
                <td class="w-4 ta-r">
                  <input v-show="false" type="text" v-model="item.total" />
                  {{ calculateTotal(item) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul class="btn-list-01">
          <li>
            <p class="link-btn-04 search ta-c mb-00">
              <a
                href="javascript: void(0);"
                class="js-modal-01"
                @click="openDialogSearchItem()"
              >
                <span>{{ $t("KYG071001.label.search_item") }}</span>
              </a>
            </p>
          </li>
          <li>
            <p class="link-btn-04 add ta-c mb-00">
              <button type="button" @click="addListItems()">
                <span>{{ $t("KYG071001.label.add_record") }}</span>
              </button>
            </p>
          </li>
        </ul>
        <b-modal
          id="searchItemDialog"
          hide-header
          hide-footer
          no-close-on-esc
          no-close-on-backdrop
          no-fade
        >
          <search-item-dialog
            :itemSearchParam="itemSearchParam"
            @addItems="bindingSearchData"
            @closeModal="closeSearchModal"
          ></search-item-dialog>
        </b-modal>
      </template>

      <!-- 代表品目名 -->
      <fieldset class="form-fieldset-01">
        <legend>
          <label for="select-03-04" class="flex">
            {{ $t("KYG021001.label.representative_item_name") }}
            <strong class="required-01">{{
              $t("KYG021001.label.required")
            }}</strong></label
          >
        </legend>
        <div class="inner">
          <!-- 品目.代表品目名1 -->
          <p class="mb-01" v-if="issueInvoiceFlg">
            <span class="form-select-01 is-large-02">
              <select
                id="select-03-04"
                v-model="packageModel.rePresent"
                class="max-width-represent-item"
                :class="{
                  'form-error-01':
                    $v.packageModel.rePresent.$error ||
                    errors.get(keyParams.representativeItemName)
                }"
                @change="removeError(keyParams.representativeItemName)"
              >
                <option :value="null" disabled>{{
                  $t("Common.option_choose")
                }}</option>
                <option
                  v-for="item in listRePresents"
                  :key="item.key"
                  :value="item.name"
                >
                  {{ item.key }}</option
                >
              </select>
            </span>
          </p>
          <!-- 品目.代表品目名2 -->
          <ul class="form-list-02" v-else>
            <li>
              <label class="form-input-01">
                <input
                  type="text"
                  id="rePresentInput"
                  :placeholder="$t('KYG071001.label.placeholder_hinname')"
                  maxlength="105"
                  v-active-validate="() => $v.packageModel.rePresent.$touch()"
                  v-model="packageModel.rePresent"
                  :class="{
                    'form-error-01':
                      $v.packageModel.rePresent.$error ||
                      errors.get(keyParams.representativeItemName)
                  }"
                  @input="removeError(keyParams.representativeItemName)"
                />
              </label>
            </li>
          </ul>
          <p class="txt-alert-01 link-txt-01">
            <strong>{{
              issueInvoiceFlg
                ? $t("KYG021001.label.representative_item_guide")
                : $t("KYG021001.label.representative_item_guide_free")
            }}</strong>
          </p>
        </div>
        <error-message
          :validate="$v.packageModel.rePresent"
          :isSelectItem="issueInvoiceFlg"
          :value="packageModel.rePresent"
          :error="errors.get(keyParams.representativeItemName)"
          :itemName="$t('KYG021001.label.representative_item_name')"
          max-digit="105"
        ></error-message>
      </fieldset>

      <div
        class="box-01"
        v-if="
          packageModel.invoiceOutDiv &&
            (issueInvoiceFlg || (!issueInvoiceFlg && displayNonDocumentItem))
        "
      >
        <fieldset class="form-fieldset-01 mb-00">
          <legend>
            <label for="input-03-05" class="flex">
              {{ $t("KYG071001.label.total_product_price") }}
              <strong
                class="required-01"
                v-show="!issueInvoiceFlg && displayNonDocumentItem"
              >
                {{ $t("KYG071001.label.required") }}
              </strong>
            </label>
          </legend>
          <div class="inner">
            <div class="form-input-02">
              <span class="input fs-02">
                <input
                  v-show="issueInvoiceFlg"
                  type="text"
                  placeholder=" "
                  class="ta-r disabled"
                  disabled
                  :value="packageModel.totalProductPrice"
                  id="input-03-05"
                />
                <input-format-number
                  v-show="!issueInvoiceFlg && displayNonDocumentItem"
                  :placeholder="
                    $t('KYG071001.label.placeholder_total_product_price')
                  "
                  maxlength="10"
                  v-active-validate="
                    () => $v.packageModel.totalProductPrice.$touch()
                  "
                  v-model="packageModel.totalProductPrice"
                  :class="{
                    'form-error-01':
                      $v.packageModel.totalProductPrice.$error ||
                      errors.get(keyParams.itemTotal)
                  }"
                  @input="removeError(keyParams.itemTotal)"
                ></input-format-number>
              </span>
              <span class="txt">
                {{ packageModel.currencyCdDisplay }}
              </span>
            </div>
            <error-message
              :validate="$v.packageModel.totalProductPrice"
              :value="packageModel.totalProductPrice"
              :itemName="$t('KYG071001.label.total_product_price')"
              :error="errors.get(keyParams.itemTotal)"
              msg-not-null="1"
              max-digit="10"
            ></error-message>
          </div>
        </fieldset>
      </div>

      <p class="ta-r link-btn-clear-01">
        <button type="button" class="js-clear-btn" @click="clearForm()">
          <span>{{ $t("KYG071001.label.issue_clear_input_items") }}</span>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import InputFormatNumber from "@/components/InputFormatNumber";

import { minLength, maxLength, required } from "vuelidate/lib/validators";
import CommonService from "@/core/utils/common-service";

import EditIssueService from "@/modules/editIssue/services/edit-issue-service";
import { CONSTANTS } from "@/constants/common-constant";
import url from "@/constants/url-const";

const delText = "KYG071001.label.delete";
const itemRawData = {
  no: 1,
  del: "",
  itemCd: null,
  itemName: null,
  hsCd: null,
  originCountry: null,
  valueOfUnit: null,
  unit: null,
  quantity: null,
  total: null
};
const rawPackageModel = {
  paidFreeKbn: null,
  grossWeight: null,
  netWeight: null,
  coolKbn: null,
  note1: null,
  note2: null,
  totalProductPrice: null,
  currencyCd: null,
  currencyCdDisplay: "",
  shipmentTerm: null,
  shipmentTermDisplay: "",
  weightUnitCd: null,
  weightUnitCdDisplay: "",

  length: null,
  width: null,
  height: null,
  paymentDiv: null,
  vatRegisterDiv: null,
  vatRegisterNumber: null,
  invoiceOutDiv: null,
  rePresent: null
};
const EDIT_ISSUE_FROM_SAVE = "01";
const LIST_LIMIT_NUMBER = 50;
const checkDecimal6Digit = value => CommonService.checkDecimal6Digit(value);
const zeroError = value => CommonService.checkZeroError(value);
const checkDecimal4Digit = value => CommonService.checkDecimal4Digit(value);
const checkDecimal = CommonService.checkDecimal();

const dummyItem = {
  itemCd: "*",
  itemName: "*",
  hsCd: "",
  originCountry: { originCountryId: "JP" },
  valueOfUnit: "1",
  unit: { unitCd: "EA" },
  quantity: "1"
};

// インボイス発行の区分
const INVOICE_OUT_DIV = {
  // 発行する
  ISSUE_INVOICE: "01",
  // 発行しない
  DO_NOT_ISSUE_INVOICE: "02"
};

// 品目.代表品目名2
// 貨物種別「書類」を選択した場合、初期値は「DOCUMENT」とする。
const REPRESENTATIVE_ITEM_NAME_DOCUMENT = "DOCUMENT";

export default {
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SearchItemDialog: () => import("@/modules/searchItem/pages/SearchItem"),
    InputFormatNumber
  },
  validations() {
    const halfNumberic = value => CommonService.checkHalfNumberic(value);
    const coolKbnHalfNumberic = value =>
      CommonService.checkHalfNumberic(value && value.sbtNaiID);

    const checkTotalPrice = value =>
      CommonService.check10Digit(
        value ? parseFloat(value.toString().replace(/[^\d.]/g, "")) : value
      );

    const checkCharCtrl01 = value => CommonService.checkCharCtrl01(value);

    const checkCharCtrl02 = value => CommonService.checkCharCtrl02(value);

    const fieldLengthCheck = param => value =>
      CommonService.fieldLengthCheck(value, param);

    const fieldLengthCheckOriginCoutryId = param => value =>
      CommonService.fieldLengthCheck(value && value.originCountryCd, param);

    const fieldLengthCheckUnitCd = param => value =>
      CommonService.fieldLengthCheck(value && value.unitCd, param);

    const halfAlphaNumbericUnitCd = value =>
      CommonService.halfAlphaNumberic(value && value.unitCd);

    const checkDupplicate = value =>
      CommonService.checkDupplicate(value, this.packageModel.listItems);

    const checkPaidDivRequired = value =>
      CommonService.checkPaidDivRequired(value, this.shipmentDiv);

    const checkPaidDivValue = value => CommonService.checkPaidDivValue(value);

    const itemNameCheck = value =>
      CommonService.itemNameCheck(value, this.packageModel.listItems);

    const checkCool = value => CommonService.checkCool(value, this.serviceKbn);

    const checkCoolKbnValue = value => CommonService.checkCoolKbnValue(value);

    const checkVatRegisterDivValid = function(value) {
      return this.isValidVatSelectionDiv(value);
    };

    return {
      packageModel: {
        grossWeight: this.validationGrossWeight,
        netWeight: this.validationNetWeight,
        paidFreeKbn: this.displayNonDocumentItem
          ? {
              checkPaidDivRequired,
              checkPaidDivValue
            }
          : {},
        rePresent: this.issueInvoiceFlg
          ? {
              required,
              fieldLengthCheck: fieldLengthCheck(105),
              checkCharCtrl02,
              itemNameCheck
            }
          : {
              required,
              fieldLengthCheck: fieldLengthCheck(105),
              checkCharCtrl02
            },
        height: this.displayNonDocumentItem ? this.validationHeight : {},
        width: this.displayNonDocumentItem ? this.validationWidth : {},
        length: this.displayNonDocumentItem ? this.validationLength : {},
        note1: {
          fieldLengthCheck: fieldLengthCheck(35),
          checkCharCtrl01
        },
        note2: {
          fieldLengthCheck: fieldLengthCheck(35),
          checkCharCtrl01
        },
        coolKbn: {
          fieldLengthCheck: fieldLengthCheck(1),
          halfNumberic: coolKbnHalfNumberic,
          checkCool,
          checkCoolKbnValue
        },
        paymentDiv: {
          required
        },
        vatRegisterDiv: this.isShowVatSetting
          ? { required,
              fieldLengthCheck: fieldLengthCheck(2),
              halfNumberic,
              checkVatRegisterDivValid: checkVatRegisterDivValid }
          : {},
        vatRegisterNumber:
          this.packageModel.vatRegisterDiv &&
          this.packageModel.vatRegisterDiv !==
            CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
            ? {
                required,
                fieldLengthCheck: fieldLengthCheck(35),
                checkCharCtrl01
              }
            : {},
        invoiceOutDiv: {
          required,
          fieldLengthCheck: fieldLengthCheck(2),
          halfNumberic
        },
        totalProductPrice:
          !this.issueInvoiceFlg && this.displayNonDocumentItem
            ? {
                required,
                checkTotalPrice,
                fieldLengthCheck: fieldLengthCheck(10),
                halfNumberic,
                zeroError
              }
            : {
                required,
                checkTotalPrice
              },
        listItems: {
          $each: {
            no: {},
            itemCd: {
              required,
              fieldLengthCheck: fieldLengthCheck(16),
              checkCharCtrl01,
              checkDupplicate
            },
            itemName: {
              required,
              fieldLengthCheck: fieldLengthCheck(105),
              checkCharCtrl02
            },
            hsCd: {
              minLength: minLength(6),
              maxLength: maxLength(15),
              checkCharCtrl01
            },
            originCountry: {
              required,
              fieldLengthCheck: fieldLengthCheckOriginCoutryId(3)
            },
            valueOfUnit: {
              required,
              fieldLengthCheck: fieldLengthCheck(10),
              halfNumberic,
              zeroError,
              checkValueTotalMoney: (value, listItems) => {
                return CommonService.checkValueTotalMoney(
                  value,
                  listItems.quantity
                );
              }
            },
            unit: {
              required,
              fieldLengthCheck: fieldLengthCheckUnitCd(3),
              halfAlphaNumberic: halfAlphaNumbericUnitCd
            },
            quantity: {
              required,
              fieldLengthCheck: fieldLengthCheck(4),
              halfNumberic,
              zeroError,
              checkValueTotalMoney: (value, listItems) => {
                return CommonService.checkValueTotalMoney(
                  value,
                  listItems.valueOfUnit
                );
              }
            },
            total: {},
            $trackBy: "no"
          }
        }
      }
    };
  },
  computed: {
    listUnit() {
      return this.$store.getters["editIssueShipment/listUnit"];
    },
    listOriginCountry() {
      return this.$store.getters["editIssueShipment/listOriginCountryMaster"];
    },
    listPaidFreeKbn() {
      return this.$store.getters["editIssueShipment/listPaidFreeKbn"];
    },
    listSizeLimit() {
      return this.$store.getters["editIssueShipment/listSizeLimit"];
    },
    listWeightLimit() {
      return this.$store.getters["editIssueShipment/listWeightLimit"];
    },
    listCoolKbn() {
      return this.$store.getters["editIssueShipment/listCoolKbn"];
    },
    currencyCd() {
      return this.$store.getters["editIssueShipment/currencyCd"];
    },
    shipmentTerm() {
      return this.$store.getters["editIssueShipment/shipmentTerm"];
    },
    weightUnidCd() {
      return this.$store.getters["editIssueShipment/weightUnidCd"];
    },
    displayNonDocumentItem() {
      return this.shipmentDiv === "N";
    },
    listPaymentDiv() {
      return this.$store.getters["editIssueShipment/listPaymentDiv"];
    },
    lengthUnidCd() {
      return this.$store.getters["editIssueShipment/lengthUnidCd"];
    },
    listInvoiceOutDiv() {
      if (this.shipmentDiv === "N") {
        return this.$store.getters[
          "editIssueShipment/listInvoiceByNonDocument"
        ];
      } else {
        return this.$store.getters["editIssueShipment/listInvoiceByDocument"];
      }
    },
    takkyubinCountryList() {
      return this.$store.getters[
        "editIssueShipment/takkyubinCountryListMaster"
      ];
    },
    listVatRegisterDiv() {
      return this.$store.getters["editIssueShipment/listVatRegisterDiv"];
    },
    listVatRegisterNotice() {
      return this.$store.getters["editIssueShipment/listVatRegisterNotice"];
    },
    listVatRegisterHint() {
      return this.$store.getters["editIssueShipment/listVatRegisterHint"];
    },
    issueInvoiceFlg() {
      return this.packageModel.invoiceOutDiv === INVOICE_OUT_DIV.ISSUE_INVOICE;
    },
    validationGrossWeight() {
      const checkWeightConflict = value =>
        CommonService.checkWeightConflict(
          value,
          this.packageModel.grossWeight,
          this.packageModel.netWeight
        );
      const checkOverSize = value =>
        CommonService.checkOverSize(
          value,
          this.serviceKbn,
          this.listWeightLimit
        );
      if (this.isActiveGrossWeight) {
        return {
          required,
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          zeroError,
          checkWeightConflict
        };
      } else {
        return {
          required,
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          checkWeightConflict
        };
      }
    },
    validationNetWeight() {
      const checkWeightConflict = value =>
        CommonService.checkWeightConflict(
          value,
          this.packageModel.grossWeight,
          this.packageModel.netWeight
        );
      const checkOverSize = value =>
        CommonService.checkOverSize(
          value,
          this.serviceKbn,
          this.listWeightLimit
        );
      if (this.isActiveNetWeight) {
        return {
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          checkWeightConflict
        };
      } else {
        return {
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          checkWeightConflict
        };
      }
    },
    validationHeight() {
      const checkHeight = value =>
        CommonService.checkHeight(
          value,
          this.packageModel.width,
          this.packageModel.length
        );
      const checkOverSizeDemension = value =>
        CommonService.checkOverSizeDemension(
          value,
          this.serviceKbn,
          this.packageModel.height,
          this.packageModel.width,
          this.packageModel.length,
          this.listSizeLimit
        );
      if (this.isActiveHeight) {
        return {
          zeroError,
          checkDecimal,
          checkDecimal4Digit,
          checkHeight,
          checkOverSizeDemension
        };
      } else {
        return {
          checkDecimal,
          checkDecimal4Digit,
          checkHeight,
          checkOverSizeDemension
        };
      }
    },
    validationWidth() {
      const checkWidth = value =>
        CommonService.checkWidth(
          this.packageModel.height,
          value,
          this.packageModel.length
        );
      const checkOverSizeDemension = value =>
        CommonService.checkOverSizeDemension(
          value,
          this.serviceKbn,
          this.packageModel.height,
          this.packageModel.width,
          this.packageModel.length,
          this.listSizeLimit
        );
      if (this.isActiveWidth) {
        return {
          zeroError,
          checkDecimal,
          checkDecimal4Digit,
          checkWidth,
          checkOverSizeDemension
        };
      } else {
        return {
          checkDecimal,
          checkDecimal4Digit,
          checkWidth,
          checkOverSizeDemension
        };
      }
    },
    validationLength() {
      const checkLength = value =>
        CommonService.checkLength(
          this.packageModel.height,
          this.packageModel.width,
          value
        );
      const checkOverSizeDemension = value =>
        CommonService.checkOverSizeDemension(
          value,
          this.serviceKbn,
          this.packageModel.height,
          this.packageModel.width,
          this.packageModel.length,
          this.listSizeLimit
        );
      if (this.isActiveLength) {
        return {
          zeroError,
          checkDecimal,
          checkDecimal4Digit,
          checkLength,
          checkOverSizeDemension
        };
      } else {
        return {
          checkDecimal,
          checkDecimal4Digit,
          checkLength,
          checkOverSizeDemension
        };
      }
    },
    // VAT種類
    listVatInputDiv() {
      const vatTypeList = this.takkyubinCountryList.find(
        country => country.countryCd === this.countryCd
      ).vatTypeList;
      const vatRegisterDivList = this.listVatRegisterDiv;
      var listVatInputDiv = new Array();
      for (let i = 0; i < vatRegisterDivList.length; i++) {
        if (
          vatRegisterDivList[i].sbtNaiID ===
          CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
        ) {
          vatRegisterDivList[i].sortNo = CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST;
          listVatInputDiv.push(vatRegisterDivList[i]);
        } else {
          for (let j = 0; j < vatTypeList.length; j++) {
            if (vatTypeList[j].type === vatRegisterDivList[i].sbtNaiID) {
              vatRegisterDivList[i].sortNo = vatTypeList[j].sortNo;
              listVatInputDiv.push(vatRegisterDivList[i]);
            }
          }
        }
      }
      return listVatInputDiv.sort(CommonService.fieldSorter(["sortNo"], "ASC"));
    },
    vatInputPlaceholder() {
      const vatTypeList = this.takkyubinCountryList.find(
        country => country.countryCd === this.countryCd
      ).vatTypeList;
      var selectedVatType = this.packageModel.vatRegisterDiv;
      const hasData = vatTypeList.some(item => item.type === selectedVatType);
      if (
        !selectedVatType ||
        !hasData ||
        selectedVatType === CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
      ) {
        selectedVatType = vatTypeList[0].type;
      }
      return this.listVatRegisterHint.find(
        registerHint => registerHint.sbtNaiID === selectedVatType
      ).stringValue;
    },
    vatSelectionDetail() {
      const vatTypeList = this.takkyubinCountryList.find(
        country => country.countryCd === this.countryCd
      ).vatTypeList;
      var selectedVatType = this.packageModel.vatRegisterDiv;
      const hasData = vatTypeList.some(item => item.type === selectedVatType);
      if (
        !selectedVatType ||
        !hasData ||
        selectedVatType === CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
      ) {
        selectedVatType = vatTypeList[0].type;
      }
      return this.listVatRegisterNotice.find(
        registerMoney => registerMoney.sbtNaiID === selectedVatType
      ).stringValue;
    },
    isShowVatSetting() {
      const selectedCountry = this.takkyubinCountryList.find(
        country => country.countryCd === this.countryCd
      );
      return (
        selectedCountry &&
        selectedCountry.vatTypeList &&
        selectedCountry.vatTypeList.length > 0
      );
    },
    isShowVatSelectCol3() {
      const selectedCountry = this.takkyubinCountryList.find(
        country => country.countryCd === this.countryCd
      );
      return (
        selectedCountry &&
        selectedCountry.vatTypeList &&
        selectedCountry.vatTypeList.length > 1
      );
    },
    isShowVatNumber() {
      return (
        this.packageModel.vatRegisterDiv !==
        CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
      );
    }
  },
  data() {
    return {
      showPackageSetting: false,
      isError: false,
      packageModel: {
        listItems: [{ ...itemRawData, del: this.$t(delText) }],
        ...rawPackageModel
      },
      itemSearchParam: null,
      isAddNewItem: false,
      listRePresents: [],
      oldRePresentIndex: 0,
      listErrorMessageItems: null,
      arrItemError: new Map(),
      isActiveGrossWeight: true,
      isActiveNetWeight: true,
      isActiveHeight: true,
      isActiveWidth: true,
      isActiveLength: true
    };
  },
  props: {
    errors: {
      type: Map,
      default: function() {
        return new Map();
      }
    },
    basicInfoLoaded: {
      type: Boolean,
      default: false
    },
    keyParams: Object,
    serviceKbn: String,
    shipmentDiv: String,
    countryCd: String,
    modeScreen: {
      type: String,
      default: ""
    },
    checkClearMsg: {
      type: Boolean,
      default: false
    },
    isUseVatSetting: {
      type: Boolean,
      default: false
    }
  },
  created() {
    //Moved screen init process to mounted
  },
  mounted() {
    if (this.basicInfoLoaded) {
      this.initScreen();
    } else {
      this.$watch("basicInfoLoaded", function(newBilVal, oldBilVal) {
        if (oldBilVal === true || newBilVal === false) {
          return;
        }

        this.initScreen();
      });
    }
  },
  updated() {
    this.$nextTick(function() {
      if (this.isAddNewItem) {
        // テーブルの最下部にスクロールする
        const tableElement = this.$el.querySelector("#table-list-item tbody");
        if (tableElement) {
          tableElement.scrollTop = tableElement.scrollHeight;
          this.isAddNewItem = false;
        }
      }
    });

    CommonService.freezeTable("table-list-item");
  },
  methods: {
    initScreen() {
      const shipment = this.$store.getters["editIssueShipment/shipment"];
      if (shipment) {
        this.restorePackageInfo(shipment);
        this.updateListPresent();
        this.getListErrorMessageItems();
      }

      this.showPackageSetting = this.errors.size > 0;
      this.$nextTick(function() {
        this.$watch("shipmentDiv", function(newVal, oldVal) {
          this.changeShipmentDiv(newVal, oldVal);
        });
        this.$watch("packageModel.invoiceOutDiv", function(newVal, oldVal) {
          this.changeInvoiceOutDiv(newVal, oldVal);
        });
        this.$watch("countryCd", function() {
          this.changeCountryCd();
          this.clearVatError();
        });
        this.$watch("packageModel.vatRegisterDiv", function() {
          this.changeVatRegisterDiv();
        });
        this.clearVatIfNeeded();
      });
    },
    restorePackageInfo(shipment) {
      if (shipment.packageInfo && shipment.packageInfo.length > 0) {
        const packageInfo = shipment.packageInfo[0];
        this.packageModel.paidFreeKbn = packageInfo.paidDiv || null;
        this.packageModel.shipmentQuantity = shipment.pcs;
        this.packageModel.grossWeight = packageInfo.grossWeight;
        this.packageModel.netWeight = packageInfo.netWeight;
        this.packageModel.coolKbn = shipment.coolDiv;
        this.packageModel.length = packageInfo.length;
        this.packageModel.width = packageInfo.width;
        this.packageModel.height = packageInfo.height;
        this.packageModel.note1 = packageInfo.note1;
        this.packageModel.note2 = packageInfo.note2;
        this.packageModel.paymentDiv = shipment.paymentDiv;
        this.packageModel.vatRegisterDiv = shipment.vatRegisterDiv;
        this.packageModel.vatRegisterNumber = shipment.vatRegisterNumber;
        this.packageModel.invoiceOutDiv = shipment.invoiceOutDiv;
        this.packageModel.rePresent = packageInfo.representativeItemName;
        this.packageModel.shipmentTerm = packageInfo.shipmentTerm;

        this.packageModel.totalProductPrice =
          !packageInfo.itemTotal || isNaN(packageInfo.itemTotal)
            ? ""
            : parseInt(packageInfo.itemTotal).toString();
        this.packageModel = this.setPropertiesCheckNull(
          this.packageModel,
          packageInfo
        );
      }
      this.setProperties();
    },
    setPropertiesCheckNull(_packageModel, packageInfo) {
      _packageModel.listItems = packageInfo.itemInfo.map((item, index) => {
        const unit = item.unitCd
          ? this.listUnit.find(
              unit => unit.unitCd.trim() === item.unitCd.trim()
            )
          : item.unitCd;
        const originCountry = item.originCountryId
          ? this.listOriginCountry.find(
              country => country.originCountryId === item.originCountryId
            )
          : item.originCountryId;
        const valueOfUnit = item.valueOfUnit
          ? parseInt(item.valueOfUnit)
          : item.valueOfUnit;
        return {
          ...item,
          no: index + 1,
          originCountry: originCountry || null,
          unit: unit || null,
          valueOfUnit:
            !valueOfUnit || isNaN(valueOfUnit) ? "" : valueOfUnit.toString()
        };
      });
      return _packageModel;
    },
    validate() {
      this.$v.$touch();
      return this.$v.$invalid;
    },
    isValidVatSelectionDiv(vatDiv) {
      return !vatDiv
          || this.listVatInputDiv.some(item => item.sbtNaiID === vatDiv);
    },
    calculateTotal(item) {
      if (item) {
        const total = CommonService.formatNumber(
          item.quantity * item.valueOfUnit
        );
        item.total = total;
        return total;
      }
      return "";
    },
    deleteItem(index) {
      const _vm = this.packageModel;
      if (_vm.listItems) {
        if (_vm.listItems.length === 1) {
          _vm.listItems = [{ ...itemRawData, del: this.$t(delText) }];
          this.$v.packageModel.listItems.$each.$reset();
          this.getListErrorMessageItems();
          this.updateListPresent();
          return;
        }
        this.packageModel.listItems.splice(index, 1);
        this.packageModel.listItems.forEach(item => {
          if (index < item.no) {
            item.no -= 1;
          }
        });
        this.$v.packageModel.listItems.$touch();
        this.getListErrorMessageItems();
        this.updateListPresent();
      }
    },
    addListItems() {
      this.$v.packageModel.listItems.$touch();
      this.getListErrorMessageItems();
      if (this.checkItemSize()) {
        const item = {
          ...itemRawData,
          del: this.$t(delText),
          no: this.packageModel.listItems.length + 1
        };
        this.packageModel.listItems.push(item);
        this.isAddNewItem = true;
        this.$v.packageModel.listItems.$each[
          this.packageModel.listItems.length - 1
        ].$reset();
        this.updateListPresent();
      }
    },
    removeEmptyItems() {
      const _vm = this.packageModel;
      _vm.listItems = _vm.listItems.filter(item => this.isNotEmptyItem(item));
      for (let i = 0; i < _vm.listItems.length; i++) {
        if (_vm.listItems[i].no !== i + 1) {
          _vm.listItems[i].no = i + 1;
        }
      }
    },
    isNotEmptyItem(item) {
      return Object.keys(item).some(function(val) {
        if (val === "no" || val === "del") {
          return false;
        } else {
          return item[val];
        }
      });
    },
    clearForm() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t("Message.clearInput")
      ).then(isClear => {
        if (isClear) {
          Object.keys(this.keyParams).forEach(key => {
            this.errors.delete(key);
          });
          CommonService.removeKeyStartsWith(this.errors, "itemInfo\\[");
          this.packageModel = {
            listItems: [{ ...itemRawData, del: this.$t(delText) }],
            ...rawPackageModel
          };
          this.setProperties();
          this.$v.packageModel.$reset();
          this.isError = false;
          this.getListErrorMessageItems();
          CommonService.scrollToItem("expandPackageInfo", "modal-top-01");
        }
      });
    },
    openDialogSearchItem() {
      const currentListSize = this.packageModel.listItems.filter(item =>
        this.isNotEmptyItem(item)
      ).length;
      if (currentListSize >= LIST_LIMIT_NUMBER) {
        const messageError = this.$t("Error.business.OverDisplayLimit", {
          0: "品目",
          1: LIST_LIMIT_NUMBER
        });
        CommonService.showDialogOk(
          this.$bvModal,
          this.$createElement,
          messageError
        );
      } else {
        this.itemSearchParam = {
          mode: "02",
          upperLimit: `${LIST_LIMIT_NUMBER}`,
          selectAble: LIST_LIMIT_NUMBER - currentListSize
        };
        this.$bvModal.show("searchItemDialog");
      }
    },
    closeSearchModal() {
      this.$bvModal.hide("searchItemDialog");
    },
    bindingSearchData(listItem) {
      this.removeEmptyItems();
      this.$v.packageModel.listItems.$touch();
      this.getListErrorMessageItems();
      const currentListItemSize = this.packageModel.listItems.length;
      for (let i = 0; i < listItem.length; i++) {
        const item = {
          no: currentListItemSize + i + 1,
          del: this.$t(delText),
          itemCd: listItem[i].itemCd,
          itemName: listItem[i].itemName,
          hsCd: listItem[i].hsCd,
          originCountry:
            this.listOriginCountry.find(
              item => item.originCountryId === listItem[i].originCountryId
            ) || null,
          valueOfUnit: listItem[i].valueOfUnit,
          unit:
            this.listUnit.find(item => item.unitCd === listItem[i].unitCd) ||
            null,
          unitName: listItem[i].unitName,
          quantity: ""
        };
        this.packageModel.listItems.push(item);
      }
      this.updateListPresent();
      this.isAddNewItem = true;
      this.closeSearchModal();
    },
    checkItemSize() {
      if (this.packageModel.listItems.length >= LIST_LIMIT_NUMBER) {
        const messageError = this.$t("Error.business.OverDisplayLimit", {
          0: "品目",
          1: LIST_LIMIT_NUMBER
        });
        CommonService.showDialogOk(
          this.$bvModal,
          this.$createElement,
          messageError
        );
        return false;
      }
      return true;
    },
    touch() {
      this.$v.packageModel.$touch();
    },
    invalid() {
      return this.$v.packageModel.$invalid;
    },
    removeError(key) {
      if (this.checkClearMsg || (this.keyParams.paymentDiv === key || this.keyParams.invoiceOutDiv === key)) {
        EditIssueService.removeError(this.errors, key);
      }
    },
    clearVatError() {
      this.removeError(this.keyParams.vatRegisterDiv);
      this.removeError(this.keyParams.vatRegisterNumber);
    },
    getListErrorMessageItems() {
      if (
        !this.packageModel.listItems &&
        (!this.errors || this.errors.size === 0)
      ) {
        return null;
      }

      let arrErrorMessage = [];
      this.arrItemError = new Map();

      for (let i = 0; i < this.packageModel.listItems.length; i++) {
        const item = this.$v.packageModel.listItems.$each[i];

        arrErrorMessage = this.checkItemError1(arrErrorMessage, item, i);

        arrErrorMessage = this.checkItemError2(arrErrorMessage, item, i);
      }
      this.listErrorMessageItems = [...new Set(arrErrorMessage)];
    },
    checkItemError1(arrErrorMessage, item, i) {
      const itemCdError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.label.header_item_code"),
        maxDigit: "16"
      };
      const itemNameError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.label.product_name"),
        maxDigit: "105"
      };
      const hsCdError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.label.header_hs_code"),
        minValue: "6",
        maxValue: "15"
      };
      const originCountryError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.label.origin_of_country"),
        maxDigit: "3"
      };
      const itemInfo = "itemInfo[";
      const itemCd = "].itemCd";
      const itemName = "].itemName";
      const hsCd = "].hsCd";
      const originCountryId = "].originCountryId";
      if (item.itemCd.$error) {
        itemCdError.validate = item.itemCd;
        itemCdError.value = item.itemCd.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(itemCdError));
        this.arrItemError.set(itemInfo + i + itemCd, true);
      }

      if (this.errors.get(itemInfo + i + itemCd)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + itemCd));
      }
      if (item.itemName.$error) {
        itemNameError.validate = item.itemName;
        itemNameError.value = item.itemName.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(itemNameError));
        this.arrItemError.set(itemInfo + i + itemName, true);
      }

      if (this.errors.get(itemInfo + i + itemName)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + itemName));
      }

      if (item.hsCd.$error) {
        hsCdError.validate = item.hsCd;
        hsCdError.value = item.hsCd.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(hsCdError));
        this.arrItemError.set(itemInfo + i + hsCd, true);
      }

      if (this.errors.get(itemInfo + i + hsCd)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + hsCd));
      }

      if (item.originCountry.$error) {
        originCountryError.validate = item.originCountry;
        originCountryError.value = item.originCountry.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(originCountryError));
        this.arrItemError.set(itemInfo + i + originCountryId, true);
      }

      if (this.errors.get(itemInfo + i + originCountryId)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + originCountryId));
      }

      return arrErrorMessage;
    },
    checkItemError2(arrErrorMessage, item, i) {
      const valueOfUnitError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.label.unit_price"),
        maxDigit: "13",
        zeroLable: this.$t("KYG071001.label.unit_price_label")
      };
      const unitCdError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.validate.params.header_unit"),
        maxDigit: "3"
      };
      const quantityError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG071001.label.quantity"),
        maxDigit: "4",
        zeroLable: this.$t("KYG071001.label.unit_price_label")
      };
      const itemInfo = "itemInfo[";
      const valueOfUnit = "].valueOfUnit";
      const unitCd = "].unitCd";
      const quantity = "].quantity";
      if (item.valueOfUnit.$error) {
        valueOfUnitError.validate = item.valueOfUnit;
        valueOfUnitError.value = item.valueOfUnit.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(valueOfUnitError));
        this.arrItemError.set(itemInfo + i + valueOfUnit, true);
      }

      if (this.errors.get(itemInfo + i + valueOfUnit)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + valueOfUnit));
      }

      if (item.unit.$error) {
        unitCdError.validate = item.unit;
        unitCdError.value = item.unit.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(unitCdError));
        this.arrItemError.set(itemInfo + i + unitCd, true);
      }

      if (this.errors.get(itemInfo + i + unitCd)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + unitCd));
      }
      if (item.quantity.$error) {
        quantityError.validate = item.quantity;
        quantityError.value = item.quantity.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(quantityError));
        this.arrItemError.set(itemInfo + i + quantity, true);
      }

      if (this.errors.get(itemInfo + i + quantity)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + quantity));
      }
      return arrErrorMessage;
    },

    updateListPresent() {
      if (!this.issueInvoiceFlg) {
        return;
      }
      const _vm = this.packageModel;
      const lstTmp = _vm.listItems
        .filter(item => item.itemName)
        .map(item => {
          var key = ("No." + Number(item.no)).padEnd(6);
          if (70 < item.itemName.length) {
            key += item.itemName.substr(0, 70) + "...";
          } else {
            key += item.itemName;
          }
          return { key: key, name: item.itemName };
        });

      this.listRePresents = lstTmp;

      if (!lstTmp.some(item => item.name === _vm.rePresent)) {
        _vm.rePresent = null;
      }
    },
    trimValue(value) {
      return CommonService.trimValue(value);
    },
    setProperties() {
      this.packageModel.currencyCd =
        this.currencyCd && this.currencyCd.sbtNaiID;
      this.packageModel.currencyCdDisplay =
        this.currencyCd && this.currencyCd.stringValue;
      if (this.shipmentDiv === "N") {
        this.packageModel.shipmentTerm =
          this.shipmentTerm && this.shipmentTerm.sbtNaiID;
      }
      this.packageModel.shipmentTermDisplay =
        this.shipmentTerm && this.shipmentTerm.stringValue;
      this.packageModel.weightUnitCd =
        this.weightUnidCd && this.weightUnidCd.sbtNaiID;
      this.packageModel.weightUnitCdDisplay =
        this.weightUnidCd && this.weightUnidCd.stringValue;
    },
    validateLengthWidthHeight() {
      this.$v.packageModel.length.$touch();
      this.$v.packageModel.width.$touch();
      this.$v.packageModel.height.$touch();
    },
    changeInvoiceOutDiv(invoiceOutDiv) {
      if (invoiceOutDiv === INVOICE_OUT_DIV.DO_NOT_ISSUE_INVOICE) {
        this.packageModel.listItems = [dummyItem];
        this.packageModel.rePresent = this.displayNonDocumentItem
          ? CONSTANTS.EMPTY_STRING
          : REPRESENTATIVE_ITEM_NAME_DOCUMENT;
        this.packageModel.totalProductPrice = this.displayNonDocumentItem
          ? CONSTANTS.EMPTY_STRING
          : "0";
      } else {
        this.packageModel.listItems = [
          { ...itemRawData, del: this.$t(delText) }
        ];
        this.updateListPresent();
      }
      this.$v.packageModel.listItems.$each.$reset();
      CommonService.removeKeyStartsWith(this.errors, "itemInfo\\[");
      this.errors.delete("itemInfo");
      this.getListErrorMessageItems();
      this.$v.packageModel.rePresent.$reset();
      this.errors.delete(this.keyParams.representativeItemName);
      this.$v.packageModel.totalProductPrice.$reset();
      this.errors.delete(this.keyParams.itemTotal);
    },
    changeShipmentDiv(newValue, oldValue) {
      if (document.getElementById("rePresentInput")) {
        document.getElementById("rePresentInput").value = null;
      }
      if (newValue === "D") {
        this.packageModel.paidFreeKbn = null;
        this.$v.packageModel.paidFreeKbn.$reset();
        this.packageModel.shipmentTerm = null;
        this.packageModel.length = "";
        this.$v.packageModel.length.$reset();
        this.packageModel.width = "";
        this.$v.packageModel.width.$reset();
        this.packageModel.height = "";
        this.$v.packageModel.height.$reset();
        this.packageModel.paymentDiv = "2";
        this.$v.packageModel.paymentDiv.$reset();
        this.removeError(this.keyParams.paymentDiv);
        // 貨物種別「書類」を選択した場合、選択値が「2:インボイスを発行しない」
        this.packageModel.invoiceOutDiv = INVOICE_OUT_DIV.DO_NOT_ISSUE_INVOICE;
      } else {
        if (oldValue) {
          this.packageModel.paymentDiv = null;
        } else {
          this.packageModel.paymentDiv = this.packageModel.paymentDiv
            ? this.packageModel.paymentDiv
            : null;
        }
        this.packageModel.shipmentTerm = this.shipmentTerm.sbtNaiID;
        // 貨物種別「書類以外の貨物」を選択した場合、選択値が「1:本システムでインボイスを発行する」
        this.packageModel.invoiceOutDiv = INVOICE_OUT_DIV.ISSUE_INVOICE;
      }
      this.$v.packageModel.invoiceOutDiv.$reset();
      this.removeError(this.keyParams.invoiceOutDiv);
      this.changeInvoiceOutDiv(this.packageModel.invoiceOutDiv);
    },
    changeCountryCd() {
      if (!this.checkClearMsg) {
        return;
      }
      // VAT種類のデフォルト設定
      this.packageModel.vatRegisterDiv = null;
      const listVatByCountry = this.takkyubinCountryList.find(
        country => country.countryCd === this.countryCd
      );
      let vatTypeList = null;
      if (listVatByCountry) {
        vatTypeList = listVatByCountry.vatTypeList;
      }
      if (vatTypeList && vatTypeList.length > 0) {
        this.packageModel.vatRegisterDiv = vatTypeList[0].type;
      }
      this.$v.packageModel.vatRegisterDiv.$reset();
      this.changeVatRegisterDiv();
    },
    // VAT登録ブロックの 詳細は「こちら(リンク)」押下時
    showVATSelectionDetail() {
      window.open(url.LINK_YMT_VAT_SELECTION_DETAIL);
    },
    changeVatRegisterDiv() {
      this.$v.packageModel.vatRegisterNumber.$reset();
      this.packageModel.vatRegisterNumber = null;
    },
    clearVatIfNeeded() {
      if (this.modeScreen === EDIT_ISSUE_FROM_SAVE) {
        if (
          !this.isUseVatSetting &&
          (this.packageModel.vatRegisterDiv ||
            this.packageModel.vatRegisterNumber)
        ) {
          CommonService.showDialogOk(
            this.$bvModal,
            this.$createElement,
            this.$t("Message.VatClearNotice")
          );
          this.packageModel.vatRegisterDiv = null;
          this.packageModel.vatRegisterNumber = null;
        }
      }
    },
    //「？(リンク)」押下時
    showHinmokuSetting() {
        window.open(
          url.LINK_ITEM_PRECAUTIONS
        );
    }
  },
  watch: {
    "packageModel.listItems": {
      handler: function(newVal) {
        if (!this.issueInvoiceFlg) {
          return;
        }
        let total = newVal
          .map(item => {
            return item.quantity * item.valueOfUnit;
          })
          .reduce(function(a, b) {
            return a + b;
          });
        total = CommonService.formatNumber(total);
        if (!total) {
          this.packageModel.totalProductPrice = "0";
        } else {
          this.packageModel.totalProductPrice = total !== 0 ? total : "0";
        }
        if (this.packageModel.totalProductPrice) {
          this.$v.packageModel.totalProductPrice.$touch();
        } else {
          this.$v.packageModel.totalProductPrice.$reset();
        }
      },
      deep: true
    },
    serviceKbn: {
      handler: function(newVal) {
        if (newVal !== "03") {
          this.$v.packageModel.coolKbn.$reset();
          this.packageModel.coolKbn = null;
        }
        if (this.displayNonDocumentItem) {
          this.$v.packageModel.height.$touch();
          this.$v.packageModel.width.$touch();
          this.$v.packageModel.length.$touch();
        }
        this.$v.packageModel.grossWeight.$touch();
      },
      deep: true
    },
    "packageModel.rePresent": {
      handler: function(newVal) {
        if (this.issueInvoiceFlg && newVal === "") {
          this.packageModel.rePresent = null;
        }
      },
      deep: true
    }
  }
};
</script>
